<template>
  <div class="header base" style="background-color:#fff;min-height: 1400px;">
    <main-header page_type="forum_list" />
    <div class="wape" style="padding:0 15px;margin-top: 10px;">
      <a-row :gutter="8" class="search-area">
        <a-col :span="20" class="input-area">
          <a-input v-model="conset" placeholder="输入你想要搜索的内容" @pressEnter="onSearchChange">
            <a-icon slot="prefix" type="search" />
            <a-icon type="plus-circle" />
          </a-input>
        </a-col>
        <a-col :span="4">
          <!-- <a-dropdown>
                        <a class="ant-dropdown-link">
                            <a-icon slot="icon" type="plus" style="color:white;font-size:30px;border-radius:25px;background-color:#ff5c00"/>
                        </a>
                        <a-menu slot="overlay">
                            <a-menu-item key="login">
                                <a href="javascript:;">我的文章</a>
                            </a-menu-item>
                            <a-menu-item key="2">
                                <a href="javascript:;">发表文章</a>
                            </a-menu-item>
                        </a-menu>
                    </a-dropdown> -->
          <button style="width:60px;height:30px;border-radius:10px;border:none" @click="goSearch(conset)">
            搜索
          </button>
        </a-col>
      </a-row>
      <div v-for="(item, index) in forumLists" :key="index">
        <div style="font-size:16px;line-hieght:24px;margin-top:37px;">
          <span style="color:#ff5c00;">#{{ item.talk_subject }}#</span>
          <span style="color:#333333;margin-left:5px" @click="gotoInfo(item.id)">{{ item.title }}</span>
        </div>
        <div class="content">
          <span style="margin-left:28px;">{{ item.abstract }}</span>
        </div>
        <div>
          <div style="margin-top:15px;border-bottom:1px solid #d2d2d2;padding-bottom:15px">
            <img src="@/assets/test-header.png" alt="" width="17px" height="17px">
            <span v-if="item.user_type === 'teacher'"
              style="margin-left:11px;font-size:12px;color:#333333;line-height:16px;" @click="goteacher(item.id)">{{
                  item.nick_name
              }}</span>
            <span v-else style="margin-left:11px;font-size:12px;color:#333333;line-height:16px;">{{ item.nick_name
            }}</span>
            <span style="float:right;margin-right:15px;line-height:16px;color:#999999;position:relative;top:3px;">{{
                item.create_time | dayFormat
            }}</span>
          </div>
        </div>
      </div>
      <van-empty v-if="forumLists.length === 0" description="暂无数据" />
      <div class="pagination">
        <van-pagination v-if="forumLists.length > 0" :value="page" :total-items="total" :show-page-size="3"
          :force-ellipses="true" @change="changePage" />
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainHeader, MainFooter } from '@/components'

export default {
  components: {
    MainHeader,
    MainFooter
  },
  data() {
    return {
      forumLists: [],
      page: 1,
      total: '',
      user_type: '',
      conset: ''
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData(e, searchkey) {
      this.$http({
        url: 'index/forum/list',
        method: 'get',
        params: {
          page: e,
          search_key: searchkey
        }
      }).then(as => {
        console.log(as)
        if (as.status === 'success') {
          var data = as.data
          this.forumLists = data.data
          this.page = data.current_page
          this.total = data.total
        } else {
          this.notifacation.error({
            message: '系统繁忙,请刷新重试',
            description: ''
          })
        }
      })
    },
    changePage(kk) {
      console.log(kk)
      // this.page = kk
      this.loadData(kk)
    },
    onSearchChange(bb) {
      console.log(bb)
      this.loadData(1, bb.target.value)
    },
    gotoInfo(id) {
      this.$router.push({ name: 'ForumInfo', params: { id: id } })
    },
    // goteacher (id) {
    //   this.$router.push({ name: 'RevealInfo', params: { id: id } })
    // }
    goteacher(id, userType) {
      if (userType === 'user') {
        return false
      } else {
        this.$router.push({ name: 'RevealInfo', params: { id: id } })
      }
    },
    goSearch(conset) {
      this.loadData(1, conset)
    }
  }
}
</script>
<style lang="stylus">
    .base {
        min-width: 280px;
        max-width: 420px;
        margin: auto;
        background-color: #fff;
    }

    .header .wape .search-area .input-area input{
        background-color:#f5f5f5;
        border-radius: 10px;
    }

    .pagination {
        margin-top: 20px;
    }

</style>
